import { Message } from 'element-ui';
export const showMessage = (message, type) => {
    Message({
        message,
        type,
    });
};